import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import { FC, useState } from "react";
import { useFiltersContext } from "../FiltersContext";
import { FiltersContent } from "./components/FiltersContent";
import { FiltersGroup } from "./components/FiltersGroup";
import { DEFAULT_SELECTED_FILTER_ITEM } from "./constants";

interface FiltersDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const FiltersDialog: FC<FiltersDialogProps> = (props) => {
  const { handleApplyFilters, handleClearFilters, handleCancelApplyFilters } =
    useFiltersContext();

  const [activeFilterId, setActiveFilterId] = useState(
    DEFAULT_SELECTED_FILTER_ITEM
  );

  const handleFilterChange = (filterId: string) => {
    setActiveFilterId(filterId);
  };

  const handleApply = () => {
    props.setIsOpen(false);
    handleApplyFilters();
  };

  const handleCancel = () => {
    props.setIsOpen(false);
    handleCancelApplyFilters();
  };

  return (
    <Dialog
      open={true}
      sx={{
        display: props.isOpen ? "auto" : "none",
      }}
      onClose={handleCancel}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle
        id="filter-dialog-title"
        sx={{ position: "relative", pr: 6, my: 1 }}
        variant="h5"
      >
        Select Filters
        <IconButton
          aria-label="close"
          onClick={handleCancel}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ p: 0, display: props.isOpen ? "auto" : "none" }}>
        <Stack direction="row" sx={{ height: 600 }}>
          <FiltersGroup
            activeFilterId={activeFilterId}
            onFilterChange={handleFilterChange}
          />
          <FiltersContent activeFilterId={activeFilterId} filters={[]} />
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions
        sx={{ padding: "16px 24px", justifyContent: "space-between" }}
      >
        <Button
          onClick={handleClearFilters}
          color="inherit"
          variant="text"
          // TODO: Implement a filter dectection logic
          // disabled={disable if has no filters to clear}
        >
          CLEAR ALL FILTERS
        </Button>
        <Stack direction="row" spacing={1}>
          <Button onClick={handleCancel} color="inherit" variant="text">
            CANCEL
          </Button>
          <Button
            onClick={handleApply}
            color="primary"
            variant="text"
            // TODO: Implement a filter dectection logic
            // disabled={disable if has no draft filters to apply}
          >
            APPLY FILTERS
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
